import { useSelector } from "react-redux";
import { AuthType } from "src/common/types/auth";
import { RootState } from "toolkit/store";

const useAuth = () => {
  const authData =
    useSelector((state: RootState) => state.auth) ||
    ({} as { data: AuthType; refreshedToken: string });

  return authData;
};

export default useAuth;
